import script from "./indexHoverGallery.vue?vue&type=script&lang=ts&setup=true"
export * from "./indexHoverGallery.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__